/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/* seo-visibility/assets/js/seo.js — Search Engine Visibility viewer.
   Reads GS.site, calls /plugin/seo-visibility/summary + /pages, renders the strip, verdict filter and
   page table. Deep-links each page's path into Heatmaps; tooltips explain verdicts and issues. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["seo-visibility"] = "1.0.5"; } catch (e) {}

  var VERDICT = {
    indexable:          { label: TR('seovis.g.indexable'),          cls: "ok",   tip: TR('seovis.p.returns_200_not_blocked_self_canonic') },
    noindex:            { label: TR('seovis.g.noindex'),            cls: "warn", tip: TR('seovis.p.carries_a_noindex_directive_meta_rob') },
    robots_blocked:     { label: TR('seovis.g.robots_blocked'),     cls: "warn", tip: TR('seovis.p.disallowed_in_robots_txt') },
    canonical_conflict: { label: TR('seovis.g.canonical_elsewhere'),cls: "warn", tip: TR('seovis.p.its_canonical_points_to_another_url_') },
    redirect:           { label: TR('seovis.g.redirect'),           cls: "mut",  tip: TR('seovis.f3.redirects_to_a_different_path_the_') },
    redirect_loop:      { label: TR('seovis.g.redirect_loop'),      cls: "bad",  tip: TR('seovis.p.the_redirect_chain_loops_back_on_its') },
    not_found:          { label: TR('seovis.g.not_found'),          cls: "bad",  tip: TR('seovis.f3.server_returns_404_410') },
    soft_404:           { label: TR('seovis.g.soft_404'),           cls: "bad",  tip: TR('seovis.p.returns_200_but_reads_as_a_not_found') },
    error:              { label: TR('seovis.g.error'),              cls: "bad",  tip: "Could not be fetched." }
  };

  function el(name) { return document.querySelector('[data-seo="' + name + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function pathOf(u) { try { return new URL(u).pathname || "/"; } catch (e) { return "/"; } }

  var CURRENT = "";       // active verdict filter
  var ROWS = [];          // current page rows (client-sorted)
  var SORT = { key: "", dir: "asc" };
  var LAST_RESCAN = "";   // url just rescanned (used to flash the row)

  // shown when an issue count is clicked open
  var ISSUE_INFO = {
    no_title:           TR('seovis.f2.no_title_tag_it_s_the_clickable_he'),
    long_title:         TR('seovis.p.title_over_65_characters_it_ll_be_tr'),
    no_desc:            TR('seovis.f2.no_meta_description_google_may_sho'),
    no_canonical:       TR('seovis.f2.no_canonical_tag_add_link_rel_cano'),
    no_https:           TR('seovis.p.served_over_http_redirect_to_https_i'),
    nofollow:           TR('seovis.f3.page_level_nofollow_links_on_this_'),
    redirect_canonical: TR('seovis.p.reached_via_a_redirect_e_g_apex_u219')
  };

  function api(q) {
    return GS.api("/plugin/seo-visibility/" + q + (q.indexOf("?") < 0 ? "?" : "&") + "site=" + encodeURIComponent(GS.site || ""))
      .then(function (r) { return (r && r.data) ? r.data : r; });
  }

  function badge(v) {
    var m = VERDICT[v] || VERDICT.error;
    return '<span class="seo-badge seo-' + m.cls + '" data-bs-toggle="tooltip" title="' + esc(m.tip) + '">' + esc(m.label) + "</span>";
  }

  function renderStrip(d) {
    var s = el("strip"); if (!s) return;
    var crawl = d.crawl || null;
    var when = crawl && crawl.finished_at ? "Last crawl " + esc(crawl.finished_at) + " UTC" : TR('seovis.f3.not_crawled_yet_run_the_seo_crawl_');
    s.querySelector(".gs-card-body").innerHTML =
        '<div class="seo-kpis">'
      + kpi(d.total, "pages crawled")
      + kpi(d.indexable_pct + "%", "indexable", d.indexable + " of " + d.total)
      + kpi(d.pages_with_issues, "with issues")
      + kpi((d.by_verdict && (d.by_verdict.not_found || 0)) + ((d.by_verdict && d.by_verdict.soft_404) || 0), "broken (404 / soft-404)")
      + "</div><div class=\"gs-muted small mt-2\">" + when + "</div>";
  }
  function kpi(v, label, sub) {
    return '<div class="seo-kpi"><b>' + esc(v) + "</b><span>" + esc(label) + "</span>"
         + (sub ? '<em class="gs-muted">' + esc(sub) + "</em>" : "") + "</div>";
  }

  function renderFilters(by) {
    var f = el("filters"); if (!f) return;
    var total = 0; Object.keys(by || {}).forEach(function (k) { total += by[k]; });
    var chips = ['<button class="seo-chip' + (CURRENT === "" ? " on" : "") + '" data-v="">'+TR('seovis.g.all')+'<b>' + total + "</b></button>"];
    Object.keys(VERDICT).forEach(function (v) {
      if (!by || !by[v]) return;
      var m = VERDICT[v];
      chips.push('<button class="seo-chip seo-' + m.cls + (CURRENT === v ? " on" : "") + '" data-v="' + v + '" data-bs-toggle="tooltip" title="' + esc(m.tip) + '">' + esc(m.label) + " <b>" + by[v] + "</b></button>");
    });
    f.innerHTML = chips.join("");
    f.querySelectorAll(".seo-chip").forEach(function (b) {
      b.addEventListener("click", function () { CURRENT = b.getAttribute("data-v"); renderFilters(by); loadPages(); });
    });
    tips(f);
  }

  var COMPARE = {
    url:     function (r) { return pathOf(r.url); },
    verdict: function (r) { return r.verdict || ""; },
    status:  function (r) { return +r.http_status || 0; },
    title:   function (r) { return (r.title || "").toLowerCase(); },
    issues:  function (r) { return (r.issues || []).length; }
  };

  function renderRows() {
    var tb = el("rows"); if (!tb) return;
    if (!ROWS.length) { tb.innerHTML = '<tr><td colspan="6" class="gs-muted small p-3">'+TR('seovis.f2.no_pages_for_this_filter')+'</td></tr>'; return; }
    var rows = ROWS.slice();
    if (SORT.key && COMPARE[SORT.key]) {
      var f = COMPARE[SORT.key], dir = SORT.dir === "desc" ? -1 : 1;
      rows.sort(function (a, b) { var x = f(a), y = f(b); return (x < y ? -1 : x > y ? 1 : 0) * dir; });
    }
    tb.innerHTML = rows.map(function (r) {
      var p = pathOf(r.url);
      var iss = (r.issues || []);
      var issCell = iss.length
        ? '<button type="button" class="seo-iss" title="Show the ' + iss.length + ' issue' + (iss.length === 1 ? "" : "s") + '">' + iss.length + '<i class="bi bi-chevron-down"></i></button>'
        : '<span class="gs-muted">0</span>';
      var detail = iss.length
        ? '<tr class="seo-issrow" hidden><td colspan="6"><div class="seo-isslist">' + iss.map(function (i) {
            return '<div class="seo-issitem"><b>' + esc(i.label) + "</b>" + (ISSUE_INFO[i.id] ? "<span>" + esc(ISSUE_INFO[i.id]) + "</span>" : "") + "</div>";
          }).join("") + "</div></td></tr>"
        : "";
      return '<tr class="seo-prow' + (r.url === LAST_RESCAN ? ' seo-flash' : '') + '">'
        + '<td class="seo-url"><a href="' + esc(r.url) + '" target="_blank" rel="noopener" title="' + esc(r.url) + '">' + esc(p) + "</a>"
        + (r.https ? "" : ' <span class="seo-http" title="'+TT('seo.tip_http')+'">http</span>') + "</td>"
        + "<td>" + badge(r.verdict) + "</td>"
        + '<td class="text-center">' + esc(r.http_status) + "</td>"
        + '<td class="seo-title">' + (r.title ? esc(r.title) : '<span class="gs-muted">—</span>') + "</td>"
        + '<td class="text-center">' + issCell + "</td>"
        + '<td class="text-end seo-actions">'
        +   '<button type="button" class="seo-rescan" data-url="' + esc(r.url) + '" title="'+TT('seo.tip_recrawl')+'"><i class="bi bi-arrow-clockwise"></i></button>'
        +   '<a class="seo-open" href="/heatmaps?page=' + encodeURIComponent(p) + '" title="'+TT('seo.tip_heatmap')+'"><i class="bi bi-graph-up"></i></a>'
        + '</td>'
        + "</tr>" + detail;
    }).join("");
    tips(tb);
  }

  function tips(scope) {
    if (window.bootstrap) (scope || document).querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (e) { try { new bootstrap.Tooltip(e); } catch (x) {} });
  }

  function loadPages() {
    var tb = el("rows"); if (tb) tb.innerHTML = '<tr><td colspan="6" class="gs-muted small p-3">Loading&#8230;</td></tr>';
    api("pages?verdict=" + encodeURIComponent(CURRENT) + "&limit=300").then(function (d) { ROWS = (d && d.pages) || []; renderCurrent(); }).catch(function () {});
  }

  function wireSort() {
    var thead = document.querySelector(".seo-table thead"); if (!thead || thead._wired) return; thead._wired = 1;
    thead.addEventListener("click", function (e) {
      var th = e.target.closest("th[data-sort]"); if (!th) return;
      var key = th.getAttribute("data-sort");
      if (SORT.key === key) SORT.dir = SORT.dir === "asc" ? "desc" : "asc";
      else { SORT.key = key; SORT.dir = (key === "issues" || key === "status") ? "desc" : "asc"; }
      thead.querySelectorAll("th[data-sort]").forEach(function (t) {
        var on = t.getAttribute("data-sort") === SORT.key;
        t.classList.toggle("sorted", on);
        t.setAttribute("data-dir", on ? SORT.dir : "");
      });
      renderRows();
    });
  }

  function rescan(url) {
    return GS.api("/plugin/seo-visibility/rescan?site=" + encodeURIComponent(GS.site || ""),
        { method: "POST", body: JSON.stringify({ url: url }) })
      .then(function (r) { var d = (r && r.data) ? r.data : r; return (d && d.ok && d.page) ? d.page : null; });
  }

  function updateRow(url, page) {
    for (var i = 0; i < ROWS.length; i++) { if (ROWS[i].url === url) { ROWS[i] = page; break; } }
    LAST_RESCAN = url;
    renderCurrent();                               // re-render whichever view is active
    api("summary").then(function (d) { if (d) { renderStrip(d); renderFilters(d.by_verdict || {}); } }).catch(function () {});
  }

  function wireRowActions() {
    var tb = el("rows"); if (!tb || tb._wired) return; tb._wired = 1;
    tb.addEventListener("click", function (e) {
      var rb = e.target.closest(".seo-rescan");
      if (rb) {
        if (rb.disabled) return;
        var url = rb.getAttribute("data-url");
        rb.disabled = true; rb.classList.add("spin");
        rescan(url).then(function (page) {
          if (page) updateRow(url, page);           // success — row replaced
          else { rb.disabled = false; rb.classList.remove("spin"); }
        }).catch(function () { rb.disabled = false; rb.classList.remove("spin"); });
        return;
      }
      var b = e.target.closest(".seo-iss");
      if (b) {
        var det = b.closest("tr").nextElementSibling;
        if (det && det.classList.contains("seo-issrow")) { det.hidden = !det.hidden; b.classList.toggle("open", !det.hidden); }
      }
    });
  }

  /* ── Pages tree (folder structure, domain first) ──────────────────────────
     Nests pages by host + path segments the way PageTree does: subdomains become
     top-level branches, the apex domain leads, branch folders are synthesised. */
  var VIEW = "tree";        // 'tree' | 'list'
  var COLLAPSED = {};       // node key -> collapsed

  function hostOf(u) { try { return new URL(u).hostname.replace(/^www\./, "").toLowerCase(); } catch (e) { return ""; } }
  function apexOf(rows) {
    var c = {}, best = "", n = -1;
    rows.forEach(function (r) { var h = hostOf(r.url); if (h) c[h] = (c[h] || 0) + 1; });
    Object.keys(c).forEach(function (h) { if (c[h] > n) { n = c[h]; best = h; } });
    return best;
  }

  function buildTree(rows) {
    var hosts = {}; rows.forEach(function (r) { var h = hostOf(r.url); if (h) hosts[h] = 1; });
    var multi = Object.keys(hosts).length > 1;
    var root = { name: "/", key: "", children: {}, page: null, host: null, isHost: false };
    rows.forEach(function (r) {
      var host = hostOf(r.url), path = pathOf(r.url), segs = [];
      if (multi && host) segs.push("@" + host);
      path.split("/").forEach(function (s) { if (s) segs.push(s); });
      if (!segs.length) { root.page = r; return; }
      var node = root, acc = "";
      segs.forEach(function (seg, i) {
        var isHost = seg.charAt(0) === "@", name = isHost ? seg.slice(1) : seg;
        acc = isHost ? "@" + name : acc + "/" + seg;
        if (!node.children[seg]) node.children[seg] = { name: name, key: acc, children: {}, page: null, host: isHost ? name : host, isHost: isHost, url: r.url };
        if (i === segs.length - 1) node.children[seg].page = r;
        node = node.children[seg];
      });
    });
    return finishTree(root, apexOf(rows));
  }
  function finishTree(node, apex) {
    node.kids = Object.keys(node.children).map(function (k) { return finishTree(node.children[k], apex); });
    node.kids.sort(function (a, b) {
      if (a.isHost || b.isHost) { var aa = (a.host === apex) ? 0 : 1, ba = (b.host === apex) ? 0 : 1; if (aa !== ba) return aa - ba; }
      var ab = a.kids.length ? 0 : 1, bb = b.kids.length ? 0 : 1;       // folders before leaf pages at a level
      if (ab !== bb) return ab - bb;
      return String(a.name).localeCompare(String(b.name));
    });
    var cnt = node.page ? 1 : 0; node.kids.forEach(function (k) { cnt += k.count; });
    node.count = cnt;
    return node;
  }
  function treeFlatten(node, depth, out) {
    node.kids.forEach(function (k) {
      out.push({ node: k, depth: depth });
      if (k.kids.length && !COLLAPSED[k.key]) treeFlatten(k, depth + 1, out);
    });
  }

  function treeRowHtml(e) {
    var n = e.node, p = n.page, branch = n.kids.length > 0;
    var label = n.isHost ? '<i class="bi bi-globe2"></i> ' + esc(n.name) : esc(n.name);
    var name = p ? '<a href="' + esc(p.url) + '" target="_blank" rel="noopener" title="' + esc(p.url) + '">' + label + "</a>" : "<span>" + label + "</span>";
    var caret = branch ? '<i class="bi bi-chevron-' + (COLLAPSED[n.key] ? "right" : "down") + ' seo-tcaret"></i>' : '<span class="seo-tspace"></span>';
    var right, detail = "";
    if (p) {
      var iss = p.issues || [];
      right = badge(p.verdict)
        + (iss.length ? ' <button type="button" class="seo-iss" title="Show the ' + iss.length + ' issue' + (iss.length === 1 ? "" : "s") + '">' + iss.length + '<i class="bi bi-chevron-down"></i></button>' : "")
        + ' <button type="button" class="seo-rescan" data-url="' + esc(p.url) + '" title="'+TT('seo.tip_recrawl')+'"><i class="bi bi-arrow-clockwise"></i></button>';
      if (iss.length) detail = '<div class="seo-tissrow" hidden style="--d:' + (e.depth + 1) + '"><div class="seo-isslist">'
        + iss.map(function (i) { return '<div class="seo-issitem"><b>' + esc(i.label) + "</b>" + (ISSUE_INFO[i.id] ? "<span>" + esc(ISSUE_INFO[i.id]) + "</span>" : "") + "</div>"; }).join("") + "</div></div>";
    } else {
      right = '<span class="seo-tcount" title="pages under this folder">' + n.count + "</span>";
    }
    return '<div class="seo-trow' + (branch ? " is-branch" : "") + '" style="--d:' + e.depth + '" data-depth="' + e.depth + '"'
      + (branch ? ' data-key="' + esc(n.key) + '"' : "")
      + '><span class="seo-tname">' + caret + name + "</span><span class=\"seo-tright\">" + right + "</span></div>" + detail;
  }

  function renderTree() {
    var host = el("tree"); if (!host) return;
    if (!ROWS.length) { host.innerHTML = '<div class="gs-muted small p-3">'+TR('seovis.f2.no_pages_for_this_filter')+'</div>'; return; }
    var tree = buildTree(ROWS), out = [];
    if (tree.page) out.push({ node: { name: "/", key: "/", kids: [], isHost: false, count: 1, page: tree.page }, depth: 0 });
    treeFlatten(tree, 0, out);
    host.innerHTML = out.map(treeRowHtml).join("");
    tips(host);
  }

  function renderCurrent() { if (VIEW === "tree") renderTree(); else renderRows(); }

  function wireTree() {
    var host = el("tree"); if (!host || host._wired) return; host._wired = 1;
    host.addEventListener("click", function (e) {
      if (e.target.closest("a")) return;
      var rb = e.target.closest(".seo-rescan");
      if (rb) {
        if (rb.disabled) return;
        var url = rb.getAttribute("data-url");
        rb.disabled = true; rb.classList.add("spin");
        rescan(url).then(function (page) { if (page) updateRow(url, page); else { rb.disabled = false; rb.classList.remove("spin"); } })
          .catch(function () { rb.disabled = false; rb.classList.remove("spin"); });
        return;
      }
      var ib = e.target.closest(".seo-iss");
      if (ib) {
        var d = ib.closest(".seo-trow").nextElementSibling;
        if (d && d.classList.contains("seo-tissrow")) { d.hidden = !d.hidden; ib.classList.toggle("open", !d.hidden); }
        return;
      }
      var row = e.target.closest(".seo-trow[data-key]"); if (!row) return;
      var key = row.getAttribute("data-key");
      COLLAPSED[key] = !COLLAPSED[key];
      renderTree();
    });
  }

  function wireViewToggle() {
    var tg = el("viewtoggle"); if (!tg || tg._wired) return; tg._wired = 1;
    tg.addEventListener("click", function (e) {
      var b = e.target.closest("[data-seo-view]"); if (!b) return;
      VIEW = b.getAttribute("data-seo-view");
      tg.querySelectorAll("[data-seo-view]").forEach(function (x) { x.classList.toggle("active", x === b); });
      var tc = el("treecard"), lc = el("listcard");
      if (tc) tc.hidden = VIEW !== "tree";
      if (lc) lc.hidden = VIEW !== "list";
      renderCurrent();
    });
  }

  /* ── Keywords tab ─────────────────────────────────────────────────────── */
  var KW_LOADED = false;
  var KW_APEX = "";

  function kwApex(groups) {
    var urls = [];
    (groups || []).forEach(function (g) { (g.pages || []).forEach(function (p) { urls.push({ url: p.url }); }); });
    return apexOf(urls);
  }
  /** order a group's pages by folder: apex host first, then host, then path. */
  function kwSortPages(pages) {
    return (pages || []).slice().sort(function (a, b) {
      var ha = hostOf(a.url), hb = hostOf(b.url);
      var aa = (ha === KW_APEX) ? 0 : 1, ba = (hb === KW_APEX) ? 0 : 1;
      if (aa !== ba) return aa - ba;
      if (ha !== hb) return ha.localeCompare(hb);
      return String(a.path).localeCompare(String(b.path));
    });
  }
  /** dim the folder portion, keep the leaf segment prominent. */
  function pathLabel(path) {
    var s = String(path || "/"), t = s.replace(/\/$/, ""), i = t.lastIndexOf("/");
    if (i <= 0) return esc(s);
    return '<span class="seo-kwdir">' + esc(s.slice(0, i + 1)) + "</span>" + esc(s.slice(i + 1));
  }

  function renderKwStrip(s) {
    var host = el("kwstrip"); if (!host || !s) return;
    host.querySelector(".gs-card-body").innerHTML = '<div class="seo-kpis">'
      + kpi(s.pages, "pages")
      + kpi(s.cannibalized, "cannibalised keywords")
      + kpi(s.unaligned, "title / H1 mismatch")
      + kpi(s.missing_desc, "no meta description")
      + kpi(s.generic, "generic / weak")
      + "</div>";
  }

  function kwFlags(p) {
    var f = [];
    if (!p.aligned) f.push('<span class="seo-flag" title="'+TT('seo.tip_titleh1')+'">title/H1</span>');
    if (!p.has_meta_desc) f.push('<span class="seo-flag" title="'+TT('seo.tip_nometa')+'">no desc</span>');
    if (p.multi_h1) f.push('<span class="seo-flag" title="'+TT('seo.tip_multih1')+'">multi-H1</span>');
    if (p.generic) f.push('<span class="seo-flag" title="'+TT('seo.tip_weakkw')+'">generic</span>');
    return f.join("");
  }
  /* Aggregate the on-page flags across a keyword's pages, so the label shows on the row itself. */
  function kwGroupFlags(g) {
    var pages = g.pages || [];
    return kwFlags({
      aligned: pages.every(function (x) { return x.aligned !== false; }),
      has_meta_desc: pages.every(function (x) { return !!x.has_meta_desc; }),
      multi_h1: pages.some(function (x) { return !!x.multi_h1; }),
      generic: !!g.generic || pages.some(function (x) { return !!x.generic; })
    });
  }

  function kwnorm(s) { return String(s || "").trim().toLowerCase(); }
  function posBadge(g) {
    var r = RANKS[kwnorm(g.keyword)]; if (!r) return "";
    var p = +r.position, tier = p <= 10 ? "good" : p <= 20 ? "mid" : "low";
    var lbl = (p % 1 === 0) ? p : p.toFixed(1);
    var tip = TR('seovis.g.avg_search_console_position') + (r.impressions ? " \u00b7 " + r.impressions + " impressions" : "") + (r.clicks ? " \u00b7 " + r.clicks + " clicks" : "") + " \u2014 click for tips";
    var id = g.kw_key || "";
    return '<span class="seo-pos seo-pos-' + tier + (POSINFO[id] ? " open" : "") + '"' + (id ? ' data-posinfo="' + esc(id) + '"' : "") + ' title="' + esc(tip) + '"><i class="bi bi-graph-up-arrow"></i>#' + lbl + "</span>";
  }
  /* Rule-based "how to improve" panel from the position + the keyword's on-page flags. */
  function linkSuggestions(g) {
    var mine = {}, myDir = "";
    (g.pages || []).forEach(function (p) { mine[p.path] = 1; });
    if (g.pages && g.pages[0]) myDir = dirOf(g.pages[0].path);
    var byPath = {};
    (KW_GROUPS || []).forEach(function (gg) {
      (gg.pages || []).forEach(function (p) {
        if (mine[p.path]) return;
        var c = p.search_clicks || 0, same = (myDir !== "" && dirOf(p.path) === myDir);
        if (!byPath[p.path] || c > byPath[p.path].clicks) byPath[p.path] = { path: p.path, clicks: c, same: same };
      });
    });
    var list = Object.keys(byPath).map(function (k) { return byPath[k]; });
    list.sort(function (a, b) { return (b.same - a.same) || (b.clicks - a.clicks); });
    return list.slice(0, 3);
  }
  function flagsRight(g) {
    var fl = kwGroupFlags(g); if (!fl) return "";
    var id = g.kw_key || "";
    return '<span class="seo-kwflags seo-flagtrig"' + (id ? ' data-posinfo="' + esc(id) + '"' : "") + ' title="'+TT('seo.tip_issues')+'">' + fl + "</span>";
  }
  function rankAdvice(g) {
    var r = RANKS[kwnorm(g.keyword)] || {}, pos = +r.position || 0, pages = g.pages || [], tips = [], kw = esc(g.keyword);
    var frame = !pos ? TR('seovis.f3.not_in_your_imported_search_consol')
      : pos <= 3 ? TR('seovis.f3.top_3_for_this_term_u2014_protect_')
      : pos <= 10 ? TR('seovis.f3.page_1_small_on_page_and_internal_')
      : pos <= 20 ? TR('seovis.f3.page_2_u2014_close_tighter_on_page')
      : TR('seovis.p.beyond_page_2_needs_clearer_on_page_');
    if (r.impressions >= 50 && (r.clicks / r.impressions) < 0.02 && pos <= 15)
      tips.push(TR('seovis.f3.plenty_of_impressions_but_few_clic'));
    if (pages.some(function (x) { return x.aligned === false; })) tips.push(TR('seovis.p.align_the_page_title_and_h1_around_u') + kw + "\u201D so the topic reads as one clear signal.");
    if (pages.some(function (x) { return !x.has_meta_desc; })) tips.push(TR('seovis.p.add_a_meta_description_containing_u2') + kw + "\u201D \u2014 it lifts click-through from the results.");
    if (pages.some(function (x) { return x.multi_h1; })) tips.push(TR('seovis.f3.the_page_has_more_than_one_h1_u201'));
    if (g.generic) tips.push(TR('seovis.p.this_term_is_broad_a_more_specific_l'));
    if (g.cannibalized) tips.push(g.page_count + " pages target this keyword and compete with each other \u2014 consolidate to one, or split their intent.");
    var links = linkSuggestions(g);
    if (links.length) {
      tips.push("Link to this page from " + links.map(function (s) {
        return "<b>" + esc(s.path) + "</b>" + (s.same ? ' <span class="seo-lnk-why">same section</span>' : s.clicks ? ' <span class="seo-lnk-why">' + s.clicks + " clicks</span>" : "");
      }).join(", ") + " \u2014 use anchor text like \u201C" + kw + "\u201D. Same-section and higher-traffic pages pass the most relevant authority.");
    } else {
      tips.push(TR('seovis.f3.as_you_publish_related_posts_link_') + kw + "\u201D.");
    }
    if (!pages.length) tips = ["No page is mapped to this keyword yet \u2014 create or tag a page that targets \u201C" + kw + "\u201D."];
    return '<div class="seo-posinfo-in"><div class="seo-posinfo-head"><i class="bi bi-lightbulb"></i> How to improve \u201C' + kw + '\u201D</div>'
      + '<div class="seo-posinfo-frame">' + esc(frame) + '</div><ul class="seo-posinfo-list">'
      + tips.map(function (t) { return "<li>" + t + "</li>"; }).join("") + "</ul></div>";
  }
  function gscPost(path) {
    return GS.api("/plugin/seo-visibility/" + path + "?site=" + encodeURIComponent(GS.site || ""), { method: "POST", body: "{}" })
      .then(function (r) { return (r && r.data) ? r.data : r; });
  }
  function loadGscStatus() {
    api("gscstatus").then(function (d) { if (!d) return; GSC = d; renderGscBar(); }).catch(function () {});
  }
  function renderGscBar() {
    var bar = el("gscbar"); if (!bar) return;
    var d = GSC || {};
    if (!d.configured) {
      bar.innerHTML = '<span class="seo-gsc-hint"><i class="bi bi-google me-1"></i>Google Search Console isn\u2019t set up yet \u2014 an admin adds the OAuth client to enable automatic rank updates.</span>';
      return;
    }
    if (!d.connected) {
      bar.innerHTML = '<button type="button" class="btn btn-outline-primary btn-sm" data-seo="gsc-connect"><i class="bi bi-google me-1"></i>'+TT('seov.js.connect_google_search_console')+'</button>'
        + '<span class="seo-gsc-hint">'+TR('seovis.pulls_your_real_positions_from_google_automa')+'</span>';
      return;
    }
    bar.innerHTML = '<span class="seo-gsc-on"><i class="bi bi-check-circle-fill"></i> Connected</span>'
      + '<span class="seo-gsc-prop">' + (d.property ? esc(d.property) : "no matching property \u2014 pick one in Search Console") + "</span>"
      + (d.last_sync ? '<span class="seo-gsc-hint">last synced ' + esc(d.last_sync) + "</span>" : "")
      + '<button type="button" class="btn btn-primary btn-sm" data-seo="gsc-sync">'+TT('seov.js.sync_now')+'</button>'
      + '<button type="button" class="btn btn-light btn-sm" data-seo="gsc-disc">'+TR('seovis.g.disconnect')+'</button>'
      + (d.error ? '<span class="seo-gsc-err" title="' + esc(d.error) + '">last error \u2014 hover</span>' : "");
  }
  function wireGsc() {
    var bar = el("gscbar"); if (!bar || bar._wired) return; bar._wired = 1;
    bar.addEventListener("click", function (e) {
      var c = e.target.closest('[data-seo="gsc-connect"]');
      if (c) { c.disabled = true; api("gscconnect").then(function (d) { if (d && d.url) location.href = d.url; else { c.disabled = false; } }).catch(function () { c.disabled = false; }); return; }
      var sy = e.target.closest('[data-seo="gsc-sync"]');
      if (sy) { sy.disabled = true; sy.textContent = TT('seo.a.syncing_u2026'); gscPost("gscsync").then(function (d) {
        sy.disabled = false; sy.textContent = TT('seo.a.sync_now');
        if (d && d.ok) { loadGscStatus(); loadRanks(); } else { renderGscBar(); }
      }).catch(function () { sy.disabled = false; sy.textContent = TT('seo.a.sync_now'); }); return; }
      var ds = e.target.closest('[data-seo="gsc-disc"]');
      if (ds) { if (!window.confirm(TT('seo.x.disconnect_google_search_console_i'))) return; gscPost("gscdisconnect").then(function () { loadGscStatus(); }); return; }
    });
  }
  function wirePosInfo() {
    var panel = document.querySelector('[data-seo-panel="keywords"]'); if (!panel || panel._posWired) return; panel._posWired = 1;
    panel.addEventListener("click", function (e) {
      var b = e.target.closest("[data-posinfo]"); if (!b) return;
      e.stopPropagation(); e.preventDefault();
      var id = b.getAttribute("data-posinfo"); POSINFO[id] = !POSINFO[id]; renderKwCurrent();
    }, true);
  }
  function loadRanks() {
    api("ranks").then(function (d) { if (!d) return; RANKS = d.latest || {}; RANK_SUMMARY = d.summary || {}; renderKwCurrent(); renderRankHint(); }).catch(function () {});
  }
  function renderRankHint() {
    var h = el("rankhint"); if (!h) return;
    var s = RANK_SUMMARY || {};
    h.textContent = s.tracked ? (s.tracked + " keywords ranked \u00b7 avg position " + s.avg_position) : TR('seovis.f3.no_rank_data_yet_u2014_import_a_se');
  }
  function importRanks(csv, date) {
    return GS.api("/plugin/seo-visibility/rankimport?site=" + encodeURIComponent(GS.site || ""),
        { method: "POST", body: JSON.stringify({ csv: csv, date: date }) })
      .then(function (r) { return (r && r.data) ? r.data : r; });
  }
  function wireRankImport() {
    var open = el("rankimport-open"), panel = el("rankpanel"), go = el("rankimport-go"), cancel = el("rankimport-cancel");
    if (!open || open._wired) return; open._wired = 1;
    var dateEl = el("rankdate"); if (dateEl && !dateEl.value) dateEl.value = new Date().toISOString().slice(0, 10);
    open.addEventListener("click", function () { if (panel) panel.hidden = !panel.hidden; });
    if (cancel) cancel.addEventListener("click", function () { if (panel) panel.hidden = true; });
    if (go) go.addEventListener("click", function () {
      var csv = (el("rankcsv") || {}).value || "", date = (el("rankdate") || {}).value || "";
      var status = el("rankstatus");
      if (!csv.trim()) { if (status) { status.textContent = TT('seo.a.paste_a_csv_first'); status.style.color = "#DC2626"; } return; }
      go.disabled = true; if (status) { status.textContent = TT('seo.a.importing_u2026'); status.style.color = "#5C6E88"; }
      importRanks(csv, date).then(function (d) {
        go.disabled = false;
        if (d && d.ok) {
          if (status) { status.textContent = TR('seovis.g.imported') + d.imported + " keyword" + (d.imported === 1 ? "" : "s") + " for " + d.date + "."; status.style.color = "#1FA463"; }
          if (el("rankcsv")) el("rankcsv").value = "";
          loadRanks();
          setTimeout(function () { if (panel) panel.hidden = true; }, 1400);
        } else {
          var msg = d && d.error === "unrecognised" ? TR('seovis.p.couldn_u2019t_read_that_csv_u2014_is') : d && d.error === "empty" ? TR('seovis.f3.the_csv_was_empty') : TR('seovis.g.import_failed');
          if (status) { status.textContent = msg; status.style.color = "#DC2626"; }
        }
      }).catch(function () { go.disabled = false; if (status) { status.textContent = TT('seo.a.import_failed'); status.style.color = "#DC2626"; } });
    });
  }

  function kwRow(g) {
    var open = !!g.cannibalized;
    var badge = g.cannibalized ? '<span class="seo-badge seo-bad" title="' + g.page_count + ' pages target the same keyword — they compete with each other in search">cannibalised \u00d7' + g.page_count + "</span>" : "";
    var pages = kwSortPages(g.pages).map(function (p) {
      return '<div class="seo-kwpage"><a href="' + esc(p.url) + '" target="_blank" rel="noopener" title="' + esc(p.url) + '">' + pathLabel(p.path) + "</a>"
        + (p.search_clicks ? '<b>' + p.search_clicks + " clicks</b>" : "")
        + '<span class="seo-kwflags">' + kwFlags(p) + "</span></div>";
    }).join("");
    return '<tr class="seo-kwr' + (open ? " open" : "") + (g.cannibalized ? " seo-kwr-can" : "") + '">'
      + '<td class="seo-kwname"><i class="bi bi-chevron-right seo-kwchev"></i> <b>' + esc(g.keyword) + "</b> " + badge + "</td>"
      + '<td class="text-center">' + g.page_count + "</td>"
      + '<td class="text-center seo-poscell">' + flagsRight(g) + posBadge(g) + (g.search_clicks ? '<span class="seo-poscnt">' + g.search_clicks + "</span>" : "") + "</td>"
      + "</tr>"
      + '<tr class="seo-kwdetail"' + (open ? "" : " hidden") + '><td colspan="3"><div class="seo-kwpages">' + pages + "</div></td></tr>"
      + (POSINFO[g.kw_key] ? '<tr class="seo-posinfo-row"><td colspan="3">' + rankAdvice(g) + "</td></tr>" : "");
  }

  function renderKwRows(groups) {
    var tb = el("kwrows"); if (!tb) return;
    if (!groups || !groups.length) { tb.innerHTML = '<tr><td colspan="3" class="gs-muted small p-3">No keyword data yet — run the SEO crawl cron.</td></tr>'; return; }
    tb.innerHTML = groups.map(kwRow).join("");
    tips(tb);
  }

  function loadKeywords() {
    api("keywords").then(function (d) { if (!d) return; KW_GROUPS = d.keywords || []; KW_APEX = kwApex(KW_GROUPS); renderKwStrip(d.summary); renderKwCurrent(); KW_LOADED = true; loadRanks(); loadGscStatus(); }).catch(function () {});
  }

  function wireKwToggle() {
    var tb = el("kwrows"); if (!tb || tb._wired) return; tb._wired = 1;
    tb.addEventListener("click", function (e) {
      if (e.target.closest("a")) return;                 // let page links through
      var row = e.target.closest(".seo-kwr"); if (!row) return;
      var det = row.nextElementSibling;
      if (det && det.classList.contains("seo-kwdetail")) { det.hidden = !det.hidden; row.classList.toggle("open", !det.hidden); }
    });
  }

  /* ── Keywords tree (keywords under the folder of their primary page) ──────── */
  var KW_VIEW = "tree";      // 'tree' | 'list'
  var KW_COLLAPSED = {};
  var KW_GROUPS = [];
  var RANKS = {}, RANK_SUMMARY = {};
  var POSINFO = {};
  var GSC = null;

  function renderKwCurrent() { if (KW_VIEW === "tree") renderKwTree(); else renderKwRows(KW_GROUPS); }

  function kwPrimary(g) {
    var ps = g.pages || [], prim = ps[0] || { url: "", path: "/" };
    ps.forEach(function (p) { if ((p.search_clicks || 0) > (prim.search_clicks || 0)) prim = p; });
    return prim;
  }
  function dirOf(path) { return path.replace(/\/[^\/]*$/, ""); }   // "/a/b"->"/a", "/a"->"", "/"->""

  function buildKwTree(groups) {
    var items = groups.map(function (g) { return { g: g, prim: kwPrimary(g) }; });
    var apex = "", c = {}, n = -1;
    items.forEach(function (x) { var h = hostOf(x.prim.url); if (h) c[h] = (c[h] || 0) + 1; });
    Object.keys(c).forEach(function (h) { if (c[h] > n) { n = c[h]; apex = h; } });
    var multi = Object.keys(c).length > 1;
    var root = { name: "/", key: "", children: {}, kws: [], host: null, isHost: false };
    items.forEach(function (x) {
      var host = hostOf(x.prim.url), folder = dirOf(pathOf(x.prim.url)), segs = [];
      if (multi && host) segs.push("@" + host);
      folder.split("/").forEach(function (s) { if (s) segs.push(s); });
      if (!segs.length) { root.kws.push(x.g); return; }
      var node = root, acc = "";
      segs.forEach(function (seg, i) {
        var isHost = seg.charAt(0) === "@", nm = isHost ? seg.slice(1) : seg;
        acc = isHost ? "@" + nm : acc + "/" + seg;
        if (!node.children[seg]) node.children[seg] = { name: nm, key: acc, children: {}, kws: [], host: isHost ? nm : host, isHost: isHost };
        node = node.children[seg];
      });
      node.kws.push(x.g);
    });
    return finishKwTree(root, apex);
  }
  function finishKwTree(node, apex) {
    node.kids = Object.keys(node.children).map(function (k) { return finishKwTree(node.children[k], apex); });
    node.kids.sort(function (a, b) { if (a.isHost || b.isHost) { var aa = (a.host === apex) ? 0 : 1, ba = (b.host === apex) ? 0 : 1; if (aa !== ba) return aa - ba; } return String(a.name).localeCompare(String(b.name)); });
    var cnt = node.kws.length; node.kids.forEach(function (k) { cnt += k.count; });
    node.count = cnt;
    return node;
  }

  function kwLeafHtml(g, depth) {
    var pages = g.pages || [], expandable = pages.length > 1;
    var badge2 = g.cannibalized ? ' <span class="seo-badge seo-bad" title="' + g.page_count + ' pages target this keyword">\u00d7' + g.page_count + "</span>" : "";
    var single = (!expandable && pages[0]) ? ' <a class="seo-kwpath" href="' + esc(pages[0].url) + '" target="_blank" rel="noopener" title="' + esc(pages[0].url) + '">' + esc(pages[0].path) + "</a>" : "";
    var clicks = g.search_clicks ? '<b class="seo-kwclicks">' + g.search_clicks + " clicks</b>" : "";
    var caret = expandable ? '<i class="bi bi-chevron-right seo-tcaret"></i>' : '<span class="seo-tspace"></span>';
    var row = '<div class="seo-trow seo-kwrow' + (g.cannibalized ? " seo-kwr-can" : "") + '" style="--d:' + depth + '"' + (expandable ? ' data-kw="' + esc(g.kw_key) + '"' : "") + ">"
      + '<span class="seo-tname">' + caret + "<b>" + esc(g.keyword) + "</b>" + badge2 + single + "</span>"
      + '<span class="seo-tright">' + flagsRight(g) + posBadge(g) + clicks + "</span></div>";
    var detail = "";
    if (expandable) {
      detail = '<div class="seo-tkwdetail" hidden style="--d:' + (depth + 1) + '"><div class="seo-kwpages">'
        + kwSortPages(pages).map(function (p) {
            return '<div class="seo-kwpage"><a href="' + esc(p.url) + '" target="_blank" rel="noopener" title="' + esc(p.url) + '">' + pathLabel(p.path) + "</a>"
              + (p.search_clicks ? "<b>" + p.search_clicks + " clicks</b>" : "") + '<span class="seo-kwflags">' + kwFlags(p) + "</span></div>";
          }).join("") + "</div></div>";
    }
    return row + detail + (POSINFO[g.kw_key] ? '<div class="seo-posinfo" style="--d:' + depth + '">' + rankAdvice(g) + "</div>" : "");
  }

  function kwTreeFlatten(node, depth, out) {
    node.kids.forEach(function (k) {
      out.push({ folder: k, depth: depth });
      if (!KW_COLLAPSED[k.key]) {
        k.kws.forEach(function (g) { out.push({ kw: g, depth: depth + 1 }); });
        kwTreeFlatten(k, depth + 1, out);
      }
    });
  }

  function renderKwTree() {
    var host = el("kwtree"); if (!host) return;
    if (!KW_GROUPS.length) { host.innerHTML = '<div class="gs-muted small p-3">No keyword data yet — run the SEO crawl cron.</div>'; return; }
    var tree = buildKwTree(KW_GROUPS), out = [];
    tree.kws.forEach(function (g) { out.push({ kw: g, depth: 0 }); });   // keywords whose page sits at the root
    kwTreeFlatten(tree, 0, out);
    host.innerHTML = out.map(function (e) {
      if (e.kw) return kwLeafHtml(e.kw, e.depth);
      var nd = e.folder, label = nd.isHost ? '<i class="bi bi-globe2"></i> ' + esc(nd.name) : esc(nd.name);
      var caret = '<i class="bi bi-chevron-' + (KW_COLLAPSED[nd.key] ? "right" : "down") + ' seo-tcaret"></i>';
      return '<div class="seo-trow is-branch" style="--d:' + e.depth + '" data-kwfolder="' + esc(nd.key) + '">'
        + '<span class="seo-tname">' + caret + "<span>" + label + "</span></span>"
        + '<span class="seo-tright"><span class="seo-tcount" title="keywords under this folder">' + nd.count + "</span></span></div>";
    }).join("");
    tips(host);
  }

  function wireKwTree() {
    var host = el("kwtree"); if (!host || host._wired) return; host._wired = 1;
    host.addEventListener("click", function (e) {
      if (e.target.closest("a")) return;
      var f = e.target.closest("[data-kwfolder]");
      if (f) { var k = f.getAttribute("data-kwfolder"); KW_COLLAPSED[k] = !KW_COLLAPSED[k]; renderKwTree(); return; }
      var kw = e.target.closest("[data-kw]");
      if (kw) { var d = kw.nextElementSibling; if (d && d.classList.contains("seo-tkwdetail")) { d.hidden = !d.hidden; kw.classList.toggle("open", !d.hidden); } }
    });
  }

  function wireKwViewToggle() {
    var tg = el("kwviewtoggle"); if (!tg || tg._wired) return; tg._wired = 1;
    tg.addEventListener("click", function (e) {
      var b = e.target.closest("[data-seo-kwview]"); if (!b) return;
      KW_VIEW = b.getAttribute("data-seo-kwview");
      tg.querySelectorAll("[data-seo-kwview]").forEach(function (x) { x.classList.toggle("active", x === b); });
      var tc = el("kwtreecard"), lc = el("kwlistcard");
      if (tc) tc.hidden = KW_VIEW !== "tree";
      if (lc) lc.hidden = KW_VIEW !== "list";
      renderKwCurrent();
    });
  }

  function wireTabs() {
    var tabs = el("tabs"); if (!tabs || tabs._wired) return; tabs._wired = 1;
    tabs.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-seo-tab]"); if (!btn) return;
      var name = btn.getAttribute("data-seo-tab");
      tabs.querySelectorAll("[data-seo-tab]").forEach(function (b) { b.classList.toggle("active", b === btn); });
      document.querySelectorAll("[data-seo-panel]").forEach(function (p) { p.hidden = p.getAttribute("data-seo-panel") !== name; });
      if (name === "keywords" && !KW_LOADED) loadKeywords();
    });
  }

  function boot() {
    if (!window.GS || !GS.api || !GS.site) return;
    if (boot._done) return; boot._done = true;
    wireSort(); wireRowActions(); wireTabs(); wireKwToggle(); wireRankImport(); wirePosInfo(); wireGsc(); wireTree(); wireViewToggle(); wireKwTree(); wireKwViewToggle();
    api("summary").then(function (d) { if (!d) return; renderStrip(d); renderFilters(d.by_verdict || {}); tips(document); }).catch(function () {});
    loadPages();
  }

  document.addEventListener("gs:ready", boot, { once: true });
  if (window.GS && GS.site) boot();
})();
